import React from "react";

import { Card, Typography, Divider, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

const MatchListWithoutMatchdays = ({ match }) => {
    const { t } = useTranslation();

    const homeTeam = t("gamedays.match.home_team");
    const awayTeam = t("gamedays.match.away_team");
    const group = t("gamedays.match.group");
    const gameId = t("gamedays.match.match_id");

    return (
        <Card
            key={match.id}
            variant="outlined"
            sx={{ width: "100%", mb: 1.5, p: 2, borderRadius: 2 }}
        >
            <Typography variant="subtitle2" color="text.secondary">
                {group} {match.groups} — {gameId} {match.id}
            </Typography>

            <Divider sx={{ my: 1 }} />

            <Grid container justifyContent="space-between">
                <Grid item>
                    <Typography color="success.main" fontWeight="bold">
                        {match.homeTeam} ({homeTeam})
                    </Typography>
                </Grid>
                <Grid item>
                    <Typography color="error.main" fontWeight="bold">
                        {match.awayTeam} ({awayTeam})
                    </Typography>
                </Grid>
            </Grid>
        </Card>
    );
};

export default MatchListWithoutMatchdays;
